































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
@Component({
    components: {}
})
export default class TabsHeader extends AbpBase {
    @Prop({type: Number,default: null}) value: number;
    @Prop({type: Array,default: ()=>{return [];}}) data: Array<any>;

    mounted() {
        
    }
    @Watch('data')
    onDataChange(newVal,oldVal) {
        if (Array.isArray(newVal)) {
            this.$emit("input",newVal[0].value);
        }
    }
    onClick(val) {
        if (val == this.value) {
            return;
        }
        this.$emit("input",val);
        this.$emit('tab-change');
    }
}
